import { EnrollModuleClass } from "../constants/enroll-module-class";

export class AdditionalModuleBase {
	enrollModule: EnrollModuleClass;
	enrollModuleQuestions: EnrollModuleQuestion[];

	constructor() {
		this.enrollModule = EnrollModuleClass.None;
		this.enrollModuleQuestions = null;
	}
}

export class EnrollModuleQuestion {
	id: number;
	isActive: boolean;
	name: string;
	questionTitle: string;
	questionForDisplay: string;
	questionResponse: string;
	hasCoveredMembers: boolean;
	hasDependencies: boolean;
	coveredMembers: CoveredMember[];
	dependencies: QuestionDependency[];

	constructor() {
		this.id = null;
		this.isActive = false;
		this.name = null;
		this.questionTitle = null;
		this.questionForDisplay = null;
		this.questionResponse = null;
		this.hasCoveredMembers = false;
		this.hasDependencies = false;
		this.coveredMembers = null;
		this.dependencies = null;
	}
}

export class CoveredMember {
	dependentID: number;
	coveredMemberName: string;
	questionResponse: string;

	constructor() {
		this.coveredMemberName = null;
		this.dependentID = null;
		this.questionResponse = null;
	}
}

export class QuestionDependency {
	dependencies: number[];
	tripDependency: string;

	constructor() {
		this.dependencies = null;
		this.tripDependency = null;
	}
}

export class AdditionalModulePayload {
	enrollModule: EnrollModuleClass;
	enrollModuleQuestions: EnrollModuleQuestionPayload[];
	enrollModuleBeneficiaries: EnrollModuleBeneficiaryPayload[];

	constructor() {
		this.enrollModule = EnrollModuleClass.None;
		this.enrollModuleQuestions = new Array<EnrollModuleQuestionPayload>();
		this.enrollModuleBeneficiaries = new Array<EnrollModuleBeneficiaryPayload>();
	}
}

export class EnrollModuleQuestionPayload {
	id: number;
	questionResponse: string;
	coveredMembers: CoveredMember[];

	constructor() {
		this.id = null;
		this.questionResponse = null;
		this.coveredMembers = null;
	}
}

export class EnrollModuleBeneficiaryPayload {
	id?: number;
	isPrimary: boolean;
	firstName: string;
	lastName: string;
	idNumber?: string;
	percentage: number;
	relationship: string;

	constructor() {
		this.id = 0;
		this.isPrimary = false;
		this.firstName = null;
		this.lastName = null;
		this.idNumber = null;
		this.percentage = 0;
		this.relationship = null;
	}
}